var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c6c6c6;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 17,
    height: 14,
    transform: "translate(0 -0.249)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.004 0.249)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.011,10.19C7.9,9.9,7.927,9.152,7.927,8.736V8.077A4.016,4.016,0,0,0,9.059,5.005V3.012A2.713,2.713,0,0,0,6.23.021,2.714,2.714,0,0,0,3.4,3.012V5.005A4.028,4.028,0,0,0,4.547,8.071v.665c0,.416.01,1.144-2.1,1.454C0,10.549,0,12.475,0,12.475V13.6H12.454V12.475a2.474,2.474,0,0,0-2.443-2.285",
    transform: "translate(0.003 -0.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.931,8.32c-1.716-.326-1.722-.849-1.722-1.189V6.592a3.352,3.352,0,0,0,1.038-2.513V2.447A2.288,2.288,0,0,0,34.836,0,2.526,2.526,0,0,0,33.2.561a3.507,3.507,0,0,0-.419.568A4.732,4.732,0,0,1,33.138,3V4.99c0,.166-.007.329-.017.491.188.636.339,1.105.339,1.105v.545c0,.272,0,.656-.887.971-.056.02-.174.054-.321.1-.078.112-.159.221-.246.323v.238a3.222,3.222,0,0,0,1.108.3,3.75,3.75,0,0,1,3.179,2.268h3.635V10.19s0-1.489-2-1.869",
    transform: "translate(-22.944 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.626dd4eb.svg";
export { ForwardRef as ReactComponent };